import React, { useState } from "react";
import Box from "../../molecules/Box";
import IconButton from "../../molecules/IconButton";
import Typography from "../../molecules/Typography";
import { ChevronLeftIcon, ChevronRightIcon } from "../../molecules/icons";
import { useStyles } from "./ImageCarousel.styles";
import { ONBOARDING_TEXT } from "../../../components/text.constants";
import Image from "common/Image";

export interface ImageCarouselProps {
  images: string[];
  className?: string;
}

const ImageCarousel = ({ images, className }: ImageCarouselProps) => {
  const classes = useStyles();
  const [current, setCurrent] = useState(0);
  const [zoomed, setZoomed] = useState(false);
  const [origin, setOrigin] = useState("50% 50%");
  const total = images.length;

  if (total === 0) return null;

  const prev = (e: React.MouseEvent) => { e.stopPropagation(); setCurrent((i) => Math.max(0, i - 1)); setZoomed(false); };
  const next = (e: React.MouseEvent) => { e.stopPropagation(); setCurrent((i) => Math.min(total - 1, i + 1)); setZoomed(false); };

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!zoomed) {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      setOrigin(`${x}% ${y}%`);
    }
    setZoomed((z) => !z);
  };

  return (
    <Box className={`${classes.root}${className ? ` ${className}` : ""}`}>
      <Box
        className={`${classes.imageWrap}${zoomed ? ` ${classes.imageWrapZoomed}` : ""}`}
        onClick={handleClick}
      >
        <Image
          src={images[current]}
          alt={`${ONBOARDING_TEXT.IMAGE_ALT_PREFIX} ${current + 1}`}
          className={zoomed ? classes.imgZoomed : undefined}
          style={{ transformOrigin: origin }}
          isProtected
        />
      </Box>

      {total > 1 && (
        <>
          <IconButton
            className={`${classes.arrowBtn} ${classes.arrowLeft}`}
            onClick={prev}
            disabled={current === 0}
            aria-label={ONBOARDING_TEXT.CAROUSEL_PREV_ARIA}
            size="small"
          >
            <ChevronLeftIcon fontSize="small" />
          </IconButton>
          <IconButton
            className={`${classes.arrowBtn} ${classes.arrowRight}`}
            onClick={next}
            disabled={current === total - 1}
            aria-label={ONBOARDING_TEXT.CAROUSEL_NEXT_ARIA}
            size="small"
          >
            <ChevronRightIcon fontSize="small" />
          </IconButton>
          <Typography className={classes.count}>{current + 1} / {total}</Typography>
        </>
      )}
    </Box>
  );
};

export default ImageCarousel;
